import React from 'react';

import gsap from 'gsap';

const ChartQuestionsHealth = () => {
  const chartTitles = [
    'Wie hoch ist die gesamte Umverteilung<br>in der OKP?',
    'Welche Umverteilungswirkung haben die Prämienzahlungen?',
    'Wer erhält und wer bezahlt Prämienverbilligungen?',
    'Wie sind die Verteilungswirkungen der Kantonsanteile an den stationären Spitalleistungen?',
  ];

  const handleClick = (anchor: string) => {
    gsap.to(window, {
      duration: 1,
      scrollTo: anchor,
      onComplete: () => {
        location.hash = anchor;
      },
    });
  };

  return (
    <div className="chartQuestions-wrapper">
      <div id="chart-questions" className="chartcontainer-anchor"></div>
      <div className="chartQuestions">
        <div className="grid-row">
          {chartTitles.map((title, index) => (
            <div className="grid-cell xs-12 md-3" key={index}>
              <div className="chartQuestion">
                <div className="chartQuestion-number">{index + 1}.</div>
                <div className="chartQuestion-content">
                  <div className="chartQuestion-text" dangerouslySetInnerHTML={{ __html: title }} />
                  <a href="javascript:void(0);" onClick={(e) => handleClick(`#graph-health-${index + 1}`)} className="chartQuestion-link">
                    MEHR ERFAHREN
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChartQuestionsHealth;
